/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The account's type.
 *
 * See the <a href="#section/Live-and-test-accounts">Live and test accounts section</a> for details.
 *
 */
export var AccountType;
(function (AccountType) {
    AccountType["LIVE"] = "live";
    AccountType["TEST"] = "test";
})(AccountType || (AccountType = {}));
//# sourceMappingURL=AccountType.js.map